import { render, staticRenderFns } from "./core_media_text.vue?vue&type=template&id=6654be26&scoped=true"
import script from "./core_media_text.vue?vue&type=script&lang=js"
export * from "./core_media_text.vue?vue&type=script&lang=js"
import style0 from "./core_media_text.vue?vue&type=style&index=0&id=6654be26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6654be26",
  null
  
)

export default component.exports